import { render } from "./sales-main.vue?vue&type=template&id=ac64aee2"
import script from "./sales-main.vue?vue&type=script&lang=js"
export * from "./sales-main.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__